"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const graphql_1 = require("graphql");
const apollo_link_1 = require("apollo-link");
const graphql_tools_1 = require("graphql-tools");
const apollo_client_1 = require("apollo-client");
const react_hooks_1 = require("@apollo/react-hooks"); // tslint:disable-line
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const react_apollo_1 = require("react-apollo");
const fragmentTypes_1 = __importDefault(require("../fragmentTypes"));
const createApolloLink = (executableSchema) => new apollo_link_1.ApolloLink(operation => {
    const { query, operationName, variables } = operation;
    return new apollo_link_1.Observable(observer => {
        graphql_1.graphql(executableSchema, graphql_1.print(query), null, null, variables, operationName)
            .then(result => {
            observer.next(result);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
});
exports.AutoMockedProvider = (props) => {
    const schema = graphql_1.buildClientSchema(props.schemaJSON);
    graphql_tools_1.addMockFunctionsToSchema({
        schema,
        mocks: props.mockResolvers
    });
    const mockedLink = createApolloLink(schema);
    const fragmentMatcher = new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
        introspectionQueryResultData: fragmentTypes_1.default
    });
    const client = new apollo_client_1.ApolloClient({
        link: mockedLink,
        cache: new apollo_cache_inmemory_1.InMemoryCache({ fragmentMatcher })
    });
    return (react_1.default.createElement(react_apollo_1.ApolloProvider, { client: client },
        react_1.default.createElement(react_hooks_1.ApolloProvider, { client: client }, props.children)));
};
